<template>
    <div class="instructor-schedule-container">
        <PreLoader v-if="isLoading"/>
        <div class="header-title" v-html="$t('mySchedule')"/>
        <div class="schedule-content">
            <div class="select-shift">
                <v-select :items="shifts" item-text="name" item-value="id" v-model="selectedShiftId" outlined dense
                          :label="$t('chooseShift')" @change="fetchShiftTimes" :no-data-text="$t('no_data')"/>
            </div>
                <v-simple-table v-if="showTable">
                    <template v-slot:default>
                <thead>
                    <tr>
                        <th v-html="$t('lesson')" style="width: 50px"/>
                        <th v-html="`Время`"/>
                        <th v-for="day in days" :key="day.day">
                            <div v-html="day.name"/>
                            <div v-html="day.date"/>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="time in shiftTimes" :key="time.id">
                        <td v-html="time.name"/>
                        <td v-html="time.startTime.slice(0,5)+' - '+time.endTime.slice(0,5)"/>
                        <td v-for="day in days" :key="day.day">
                            <div class="lesson" v-if="getSpecificClassSchedule(day.day, time.id).length">
                                <div v-for="klass in getSpecificClassSchedule(day.day, time.id)">
                                    {{ klass.classLevel + klass.classLabel + ' - ' + (klass[langObj[currentLang]] === null ? $t('no_data') : klass[langObj[currentLang]]) }}
                                </div>
                            </div>
                            <div class="lesson" v-else></div>
                        </td>
                    </tr>
                </tbody>
                    </template>
                </v-simple-table>
        </div>
    </div>
</template>

<script>
import ClassSelectHeader from '@/components/instructor/ClassSelectHeader'
import ScheduleWeekService from '@/_services/schedule-week.service'
import ShiftService from '@/_services/shift.service'
import ShiftTimeService from '@/_services/shift-time.service'
import PreLoader from '@/components/preloader/PreLoader'
import moment from 'moment'

export default {
  components: {
    ClassSelectHeader,
    PreLoader
  },

  computed: {
    userProfile () {
      return this.$store.state.account.profile
    },
    school () {
      return this.userProfile.schools[0]
    },
    currentLang () {
      return this.$root.$i18n.locale
    },
    days () {
      return [
        { day: 1, name: this.$t('monday') },
        { day: 2, name: this.$t('tuesday') },
        { day: 3, name: this.$t('wednesday') },
        { day: 4, name: this.$t('thursday') },
        { day: 5, name: this.$t('friday') },
        { day: 6, name: this.$t('saturday') }
      ]
    }
  },

  data () {
    return {
      // days: [
      //   { day: 1, name: this.$t('monday') },
      //   { day: 2, name: this.$t('tuesday') },
      //   { day: 3, name: this.$t('wednesday') },
      //   { day: 4, name: this.$t('thursday') },
      //   { day: 5, name: this.$t('friday') },
      //   { day: 6, name: this.$t('saturday') }
      // ],
      langObj: {
        ru: 'courseTitle',
        kg: 'courseTitleKG',
        en: 'courseCode'
      },
      showTable: false,
      isLoading: false,
      teacherSchedules: [],
      shifts: [],
      allShifts: [],
      shiftTimes: [],
      selectedShiftId: ''
    }
  },

  // mounted () {
  //   this.days = [
  //     { day: 1, name: this.$t('monday') },
  //     { day: 2, name: this.$t('tuesday') },
  //     { day: 3, name: this.$t('wednesday') },
  //     { day: 4, name: this.$t('thursday') },
  //     { day: 5, name: this.$t('friday') },
  //     { day: 6, name: this.$t('saturday') }
  //   ]
  // },

  created () {
    this.isLoading = true
    this.setCurrentDates()
    this.fetchAllSchoolShifts()
  },

  methods: {
    setCurrentDates () {
      const date = new Date()
      this.days.map((item) => {
        item.date = moment(new Date(date.setDate(date.getDate() - date.getDay() + item.day))).format('DD.MM.YYYY')
        return item
      })
    },

    fetchAllSchoolShifts () {
      ShiftService.getAllBySchool(this.school.id).then((res) => {
        if (res.length) {
          this.allShifts = res
          this.fetchInstructorSchedule()
        } else {
          this.isLoading = false
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchInstructorSchedule () {
      ScheduleWeekService.getByInstructor(this.userProfile.personId).then((res) => {
        this.teacherSchedules = res

        const instrUniqueShiftIds = res.filter((obj, index, selfArr) =>
          index === selfArr.findIndex((el) =>
            (el.shiftId === obj.shiftId)
          )).map((shiftObj) => shiftObj.shiftId)

        this.allShifts.forEach((item) => {
          if (instrUniqueShiftIds.includes(item.id)) {
            this.shifts.push(item)
          }
        })

        if (this.shifts.length) {
          this.selectedShiftId = this.shifts[0].id
          this.fetchShiftTimes(this.selectedShiftId)
        } else {
          this.isLoading = false
        }
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    fetchShiftTimes (shiftId) {
      this.isLoading = true
      this.showTable = false
      ShiftTimeService.getAllByShiftId(shiftId).then((res) => {
        this.shiftTimes = res.sort((a, b) => a.name - b.name)
        this.showTable = true
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    getSpecificClassSchedule (day, timeId) {
      return this.teacherSchedules.filter(schedule => schedule.weekDay === day && schedule.shiftTimeId === timeId)
    }
  }
}
</script>

<style lang="scss" scoped>
th{
    font-size: 14px!important;
    font-weight: bold!important;
}
th, td {
    vertical-align: middle;
    text-align: center!important;
    border: rgba(198, 203, 212, 0.58) solid 1px;
    min-width: 90px!important;
}
.header-title {
    margin-bottom: 15px;
    font-size: 28px;
    font-weight: bold;
}
    .instructor-schedule-container {
        padding: 30px;
        .schedule-content {
            margin-top: 25px;
            .select-shift {
                max-width: 300px;
                margin: 0;
            }
        }
    }
    th, td {
        vertical-align: middle;
    }
@media screen and (max-width: 768px){
    .instructor-schedule-container{
        padding: 10px;
        .schedule-content {
            .select-shift {
                max-width: none;
                width: 100%;
            }
        }
    }
}
</style>
